module.exports = __webpack_public_path__ + "img/event2.c530dc31.png";